import { BASE_ADMIN_API_ROOT_PATH } from '../../shared/api/constants/path.constants';

const ADMIN_SEGMENTS_API_ROOT = `${BASE_ADMIN_API_ROOT_PATH}/segments`;

export const ADMIN_SEGMENTS_API_PATHS = {
  GET_SEGMENTS: `${ADMIN_SEGMENTS_API_ROOT}`,
  CREATE_SEGMENT: `${ADMIN_SEGMENTS_API_ROOT}`,
  GET_SEGMENT_BY_ID: (segmentId: string) => `${ADMIN_SEGMENTS_API_ROOT}/${segmentId}`,
  UPDATE_SEGMENT: (segmentId: string) => `${ADMIN_SEGMENTS_API_ROOT}/${segmentId}`,
  ARCHIVE_SEGMENT: (segmentId: string) => `${ADMIN_SEGMENTS_API_ROOT}/${segmentId}`,
  RESTORE_SEGMENT: (segmentId: string) => `${ADMIN_SEGMENTS_API_ROOT}/${segmentId}/restore`,
};
